import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../Icon";
import { PageHero, useSeo } from "../ui";

export default function NotFound() {
  useSeo({ title: "페이지를 찾을 수 없습니다 — I.META", noindex: true });

  return (
    <PageHero
      kicker="404"
      title="페이지를 찾을 수 없습니다"
      desc="주소가 바뀌었거나 삭제된 페이지입니다."
    >
      <div className="hero__actions">
        <Link to="/" className="btn btn--primary">
          홈으로 <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
        </Link>
        <Link to="/contact" className="btn btn--ghost">개발 문의 하기</Link>
      </div>
    </PageHero>
  );
}
